import { globalStyle, style } from '@vanilla-extract/css';
import { mobile, vars } from '@/shared/ui/theme';

/* 승인된 시안(Pages/TodayPage/FullTodayWorklog)의 읽기 모양을 그대로 옮겼다. */

export const reader = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.lg,
  minWidth: 0,
  padding: vars.spacing.padding.md,
  color: vars.typography.textColor.primary,
});
globalStyle(`${reader} :is(p, h3, h4, summary)`, {
  wordBreak: 'keep-all',
  overflowWrap: 'anywhere',
});

export const tools = style({ display: 'flex', flexDirection: 'column', gap: vars.spacing.gap.sm });
export const period = style({ color: vars.typography.textColor.secondary });
export const periodSummary = style({
  cursor: 'pointer',
  fontSize: vars.typography.fontSize.sm,
  minHeight: '2.75rem',
  display: 'flex',
  alignItems: 'center',
});
export const range = style({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: vars.spacing.gap.sm,
  marginTop: vars.spacing.gap.md,
  '@media': { [mobile]: { gridTemplateColumns: '1fr' } },
});
export const actions = style({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: vars.spacing.gap.sm,
  marginTop: vars.spacing.gap.sm,
});
export const toolbar = style({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: vars.spacing.gap.sm,
});
export const small = style({
  color: vars.typography.textColor.tertiary,
  fontSize: vars.typography.fontSize.xs,
  margin: 0,
});
export const muted = style({
  color: vars.typography.textColor.secondary,
  fontSize: vars.typography.fontSize.sm,
  margin: 0,
});
export const context = style({
  background: vars.surface.liquidGlass.innerSurface.background,
  padding: vars.spacing.padding.md,
  borderRadius: vars.spacing.borderRadius.md,
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.sm,
});

export const entry = style({
  borderTop: `1px solid ${vars.surface.border.secondary}`,
  paddingTop: vars.spacing.padding.lg,
});
export const date = style({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: vars.spacing.gap.sm,
  margin: '0 0 0.75rem',
  fontSize: vars.typography.fontSize.sm,
  fontWeight: vars.typography.fontWeight.semibold,
  fontFamily: vars.typography.fontFamily.mono,
  fontVariantNumeric: 'tabular-nums',
});
export const memo = style({
  margin: 0,
  marginBottom: vars.spacing.gap.md,
  color: vars.typography.textColor.primary,
  fontSize: vars.typography.fontSize.base,
  lineHeight: 1.8,
  whiteSpace: 'pre-wrap',
});
export const memoEmpty = style({
  margin: 0,
  marginBottom: vars.spacing.gap.md,
  color: vars.typography.textColor.tertiary,
  fontSize: vars.typography.fontSize.sm,
});
export const group = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.sm,
  marginTop: vars.spacing.gap.md,
});
export const groupTitle = style({
  color: vars.typography.textColor.tertiary,
  fontSize: vars.typography.fontSize.xs,
  fontWeight: vars.typography.fontWeight.medium,
  margin: 0,
});
export const record = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.xs,
  padding: vars.spacing.padding.md,
  borderRadius: vars.spacing.borderRadius.sm,
  background: vars.surface.card.default,
});
export const recordTitle = style({
  fontSize: vars.typography.fontSize.sm,
  color: vars.typography.textColor.primary,
  fontWeight: vars.typography.fontWeight.medium,
  margin: 0,
});
export const recordMemo = style({
  fontSize: vars.typography.fontSize.sm,
  color: vars.typography.textColor.secondary,
  margin: 0,
});
